import React from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import type { ExtractStringKeys } from '../../../../../react-commons/types/extractKeysOfType';
import { LazyVideoContentDisplay } from './LazyVideoContentDisplay';

export const FormVideoContentDisplay = <T extends object>({
    projectVersionId,
    name,
    form,
}: {
    projectVersionId: string | undefined | null;
    form: UseFormReturn<T>;
    name: ExtractStringKeys<T, false>;
}) => {
    const videoWatcher = useWatch({
        control: form.control,
        name
    })

    return <LazyVideoContentDisplay videoAttachmentObjectId={videoWatcher} versionedIn={projectVersionId ?? ""} height={null}/>
};
